package com.gsb.vyapar.bhagya.presentation.category.event

import com.gsb.vyapar.bhagya.domain.Categories.D.Category
import com.gsb.vyapar.bhagya.domain.SubCategories.D.SubCategory

sealed class CategoriesViewUiEvents {
    data class AddEditCategory(val addEditCategory: Category?) : CategoriesViewUiEvents()
    data class AddEditCategoryName(val name: String) : CategoriesViewUiEvents()
    data class AddEditCategoryImageUpload(val image: ByteArray, val fileName: String) : CategoriesViewUiEvents()
    data class AddEditCategoryDeleted(val deleted: Boolean) : CategoriesViewUiEvents()
    data object AddEditCategorySave : CategoriesViewUiEvents()
    data object SaveCategories: CategoriesViewUiEvents()
    data object SaveSubCategories: CategoriesViewUiEvents()
    data class AddEditSubCategory(val addEditSubCategory: SubCategory?) : CategoriesViewUiEvents()
    data class AddEditSubCategoryName(val name: String) : CategoriesViewUiEvents()
    data class AddEditSubCategoryCategoryMenuIndex(val categoryMenuIndex: Int) : CategoriesViewUiEvents()
    data class AddEditSubCategoryDeleted(val deleted: Boolean) : CategoriesViewUiEvents()
    data object AddEditSubCategorySave : CategoriesViewUiEvents()
    data class ShowCategory(val category: Category?) : CategoriesViewUiEvents()
}